module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/zh-hant/6-1314e234547d39c062101526df40eaf2.jpg";